import styled from '@emotion/styled';

interface HoverProps {
	isHover?: boolean;
	defaultColor?: string;
	isAuthPath?: boolean;
	isScrolled?: boolean;
}

interface ColorProps {
	defaultColor: string;
}
export const HeaderContainer = styled.header<HoverProps>`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	background: ${(props) => props.defaultColor};
	backdrop-filter: blur(10px);
	height: ${(props) => (props.isHover ? `${props.theme.heights.headerHover}` : `${props.theme.heights.header}`)};
	z-index: 10;
	border-bottom: ${(props) => (props.isAuthPath ? '1px solid #dee2e6' : props.isScrolled ? '1px solid #dee2e6' : 'none')};
	@media screen and (max-width: 1180px) {
		height: ${(props) => props.theme.heights.headerMobile};
		background: ${(props) => props.defaultColor};
	}
`;

export const Nav = styled.nav<HoverProps>`
	display: flex;
	align-items: ${(props) => (props.isHover ? `flex-start` : `center`)};

	justify-content: space-between;
	position: relative; // 추가!
	max-width: 184rem;
	margin: 0 auto;
	height: ${(props) => (props.isHover ? `${props.theme.heights.headerHover}` : `${props.theme.heights.header}`)};
	padding: 0.8rem 2rem;
	@media screen and (max-width: 1180px) {
		height: ${(props) => props.theme.heights.headerMobile};
		align-items: center;
	}
`;

export const MenuList = styled.div<HoverProps>`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	display: grid;

	/* isHover에 따라 흐름 결정 */
	grid-auto-flow: column;

	/* isHover일 때는 열이 아니라 "행"을 세팅 */
	grid-template-columns: 12rem 12rem 12rem 16rem 12rem;
	grid-auto-rows: minmax(70px, auto);
	justify-items: center;
	align-items: start;

	@media screen and (max-width: 1180px) {
		display: none;
	}
`;

export const SubMenuList = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export const MenuItem = styled.div<HoverProps>`
	color: ${(props) => props.defaultColor};
	font-size: 2rem;
	font-weight: 600;
	line-height: 130%;
	letter-spacing: -0.6px;
	white-space: nowrap;
	display: flex;
	height: 7rem;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	&.sub {
		height: 4.8rem;
		font-size: 1.8rem;
		font-weight: 400;
		color: #495057;
		:hover {
			color: #01337d;
			font-weight: 600;
		}
	}
`;

export const AuthBox = styled.div<{ isLogin: boolean }>`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-auto-rows: minmax(70px, auto);
	gap: 2.4rem;
	justify-items: center;
	align-items: center;

	@media screen and (max-width: 1180px) {
		gap: 1.8rem;
		grid-template-columns: ${(props) => (props.isLogin ? '7.2rem 2.4rem' : '5.5rem 2.4rem')};
		grid-auto-rows: minmax(28px, auto);
		gap: 1.2rem;
	}
`;

export const AuthButton = styled.button<ColorProps>`
	background: transparent;
	border: none;
	color: ${(props) => props.defaultColor};
	font-size: 1.8rem;
	font-weight: 600;
	line-height: 130%;
	letter-spacing: -0.6px;
	cursor: pointer;
	@media screen and (max-width: 1180px) {
		font-size: 1.6rem;
		font-weight: 700;
		line-height: 100%;
	}
`;

export const UserButton = styled.button`
	padding: 0rem 0.8rem;
	border-radius: 9999px;
	background: #01337d;
	height: 2.8rem;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.2rem;
	border: none;
	color: white;
	font-size: 1.4rem;
	font-weight: 700;
	line-height: normal;
	letter-spacing: -0.6px;
	cursor: pointer;
`;

export const LogoBox = styled.div`
	display: flex;
	/* width: 20rem;
	height: 7rem; */
`;

export const ImgBox = styled.div`
	width: 20rem;
	height: 7rem;

	@media screen and (max-width: 1180px) {
		width: 13rem;
		height: 3.9rem;
	}

	img {
		width: 100%;
	}
`;
